<script>
	import CaseStudy from '$lib/Components/CaseStudy/CaseStudy.svelte';
	import Grid from '$lib/Components/Layout/Grid/Grid.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import Awards from '$lib/PageSections/Awards/Awards.svelte';
	import FeaturedArticles from '$lib/PageSections/FeaturedArticles/FeaturedArticles.svelte';
	import GetAFreeEstimate from '$lib/PageSections/GetAFreeEstimate/GetAFreeEstimate.svelte';

	import faqImage from './images/resources-hub-001.jpg';
	import windowPreservationImage from './images/resources-hub-002.jpg';
	import soundproofingImage from './images/resources-hub-003.jpg';
	import blogImage from './images/resources-hub-004.jpg';
	import caseStudiesImage from './images/resources-hub-005.jpg';
	import measurementEquipmentImage from './images/resources-hub-006.jpg';
	import windowGuides from './images/resources-hub-007.png';
</script>

<Section backgroundColor={'white'} class="section__resources">
	<p>
		Whether you're looking to better understand how to soundproof your home or
		restore and preserve historic windows, the resources below will teach you
		everything you need to know. We've got you covered when it comes to window
		insulation tips for your home.
	</p>
	<hr />
	<Grid columns={3} rows={4} center>
		<Grid subgrid vertical>
			<CaseStudy
				title="Case Studies"
				href="/resources/case-studies"
				src={caseStudiesImage}
				alt="Window insulation tips."
				description="Read what our clients have said about window insert projects that have improved their quality of life by blocking drafts, noise, or controlling light. Navigate our articles by category or read them all!"
				learnMore="Continue Reading"
				subgrid
			/>
		</Grid>

		<Grid subgrid vertical>
			<CaseStudy
				title="Frequently Asked Questions"
				href="/resources/faq/"
				src={faqImage}
				alt="Window insulation tips."
				description="Indow window inserts are custom-made and solve all kinds of issues from condensation to noise penetration. Want to know more? Read our answers to frequently asked questions."
				learnMore="Continue Reading"
				subgrid
			/>
		</Grid>

		<Grid subgrid vertical>
			<CaseStudy
				title="Measure & Installation Support"
				href="/about-indow/how-to-order/measure"
				src={measurementEquipmentImage}
				alt="Window insulation tips."
				description="Current or former Indow customer? This is the resource page for you. From measurement to receiving & handling, to videos on how to install and adjust your inserts, you can find it here."
				learnMore="Continue Reading"
				subgrid
			/>
		</Grid>
	</Grid>

	<hr class="hidden md:block" />

	<Grid columns={3} rows={4} center>
		<Grid subgrid vertical>
			<CaseStudy
				title="Soundproofing Your Home"
				href="/resources/soundproofing-windows/"
				src={soundproofingImage}
				alt="Window insulation tips."
				description="Home soundproofing doesn't have to be expensive. Learn how to soundproof your house using high-performance window inserts and more."
				learnMore="Continue Reading"
				subgrid
			/>
		</Grid>

		<Grid subgrid vertical>
			<CaseStudy
				title="Window Guides"
				href="/resources/window-guides"
				src={windowGuides}
				alt="Window insulation tips."
				description="The Windows Guide is a resource page dedicated to the technical side of windows & window inserts. Explore pages based on window type, building type, or special topics. Compare types of windows, storm window solutions, or pros & cons of window replacement vs. retrofit solutions."
				learnMore="Continue Reading"
				subgrid
			/>
		</Grid>

		<Grid subgrid vertical>
			<CaseStudy
				title="Window Preservation"
				href="/resources/historic-preservation/"
				src={windowPreservationImage}
				alt="Window insulation tips."
				description="Learn from historic window preservation experts how to restore old windows and how to protect, maintain and renovate historic properties or browse through our historic affiliations."
				learnMore="Continue Reading"
				subgrid
			/>
		</Grid>
	</Grid>

	<hr class="hidden md:block" />

	<div class="md:w-1/3">
		<Grid vertical center>
			<CaseStudy
				title="Featured Articles"
				href="/resources/featured-articles"
				src={blogImage}
				alt="Window insulation tips."
				description="Read about company developments and what Indow is doing to help address climate change, promote window restoration, and improve the built environment."
				learnMore="Countinue Reading"
				subgrid
			></CaseStudy>
		</Grid>
	</div>
</Section>
<GetAFreeEstimate />
<Awards />
<FeaturedArticles />
